import React from 'react';
import './StatusBar.css';

export default function StatusBar({ loading, error, count, total, days }) {
  let message;
  if (loading) {
    message = 'Fetching wildfire data from NASA EONET…';
  } else if (error) {
    message = error;
  } else {
    message = `Showing ${count} of ${total} wildfire events · Last ${days} days · NASA EONET v3`;
  }

  return (
    <div className={`status-bar ${error ? 'status-error' : ''}`}>
      <span className={`status-dot ${loading ? 'status-dot-loading' : error ? 'status-dot-error' : 'status-dot-ok'}`} />
      <span className="status-text">{message}</span>
    </div>
  );
}
